"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPassword = exports.getEmailVcode = exports.forgetPwd = exports.goOut = exports.goLogin = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 登录
exports.goLogin = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/login', params); });
// 退出登录
exports.goOut = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/logout', params); });
// 修改密码
exports.forgetPwd = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/modifyPwd', params); });
// 获取邮箱验证码
exports.getEmailVcode = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/sendMailCode', params); });
// 邮箱验证码重置密码
exports.resetPassword = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerContacts/resetPwd', params); });
